import http, { getTenantFromUrl } from "../helpers/http";

export const resetPasswordRequest = async (email, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Password reset request sent (Mock)", data: {} };
  }
  const response = await http().get(
    `/Account/ResetPasswordRequest?email=${email}`
  );
  return response.data;
};

export const confirmEmail = async (payload) => {
  const response = await http(true).post("/account/confirmemail", payload);
  return response.data;
};

export const completePasswordReset = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Password reset successful (Mock)", data: {} };
  }
  const response = await http().post("/Account/ResetPassword", payload);
  return response.data;
};
